import { useState } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { useRecoilState } from 'recoil';
import {
  GET_SOLICITIATION_LINES,
  UPDATE_SOLICITATION_LINE,
} from '../../queries';
import solicitationNotifications from '../../utils/solicitation-notification-helpers';
import { pageErrorNotifications } from '../../../../utilities/error-handling';

export default function useAssignQuantity(solicitationID) {
  const [originalLines, setOriginalLines] = useState([]);
  const [solicitationLines, setSolicitationLines] = useState([]);
  const [notifications, setSolicitationNotification] = useRecoilState(
    solicitationNotifications,
  );

  const { loading: solicitationLineLoading } = useQuery(
    GET_SOLICITIATION_LINES,
    {
      skip: !solicitationID,
      variables: {
        solicitationID: Number(solicitationID),
        limit: 9999,
        offset: 0,
      },
      fetchPolicy: 'network-only',
      onCompleted: ({ getSolicitationLines }) => {
        const lines = getSolicitationLines.rows;
        const strippedLines = lines.map(
          ({ id, standardItem, estimatedQty, estimatedFleetQty }) => ({
            id,
            standardItem,
            estimatedQty,
            estimatedFleetQty,
          }),
        );
        setOriginalLines(strippedLines);
        setSolicitationLines(strippedLines);
      },
    },
  );

  const [updateSolicitationLine] = useMutation(UPDATE_SOLICITATION_LINE, {
    // onCompleted is set when the mutation is called
    onError: (requestError) => {
      setSolicitationNotification([
        ...pageErrorNotifications(requestError, {
          id: 'UPDATE_SOLICITATION_LINE_ERROR',
          message: requestError.message,
          type: 'error',
          closeable: false,
          showInModal: false,
        }),
      ]);
    },
  });

  return {
    originalLines,
    setOriginalLines,
    solicitationLines,
    setSolicitationLines,
    updateSolicitationLine,
    setSolicitationNotification,
    notifications,
    solicitationLineLoading,
  };
}
